import script from "./DefaultSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultSelect.vue?vue&type=script&setup=true&lang=js"

import "./DefaultSelect.vue?vue&type=style&index=0&id=8213f030&lang=css"

const __exports__ = script;

export default __exports__